export default __webpack_public_path__ + "img/fontello.b5c4799196bd23c31c0c1047e23eb29a.svg";